<app-iota-modal [modalOptions]="modalOptions" (close$)="close()">
    <h5 modal-header>{{ data?.title || 'Dokumente hochladen' }}</h5>
    <div modal-body class="p-5 flex flex-col gap-3">
        <p>{{ data.text }}</p>
    </div>

    <div modal-footer class="flex flex-row grow justify-between items-center gap-2">
        <div class="grow"></div>
        <button class="btn btn-primary" (click)="dialogRef.close()" i18n>Close</button>
    </div>
</app-iota-modal>
